import React, { Fragment, useState, useEffect } from 'react';

import { Modal, ModalBody, ModalHeader } from 'reactstrap';

const AuctionInfoModal = ({
  expiredCard,
  overduePayment,
}) => {
  const [isAuctionModal, setIsAuctionModal] = useState(false);

  useEffect(() => {
    if (expiredCard || overduePayment) {
      setIsAuctionModal(true);
    }
    // eslint-disable-next-line
  }, []);

  useEffect(() => {
    if (expiredCard || overduePayment) {
      setIsAuctionModal(true);
    }
  }, [expiredCard, overduePayment]);

  const toggle = () => setIsAuctionModal(!isAuctionModal);

  const expiredCardText = (
    <Fragment>
      Your credit card on file has expired. To avoid interruption in service, please update your credit card information, or contact Invaluable Customer Care at 617-746-9800 or <a href="mailto:auctions@invaluable.com">auctions@invaluable.com</a> to update your card';
    </Fragment>
  );
  const overdueBalanceText = (
    <Fragment>
      You account has an outstanding balance. To avoid interruption in service, please contact invaluable Customer Care at 617-746-9800 or <a href="mailto:auctions@invaluable.com">auctions@invaluable.com</a> to pay amount due.
    </Fragment>
  );

  const renderModalBody = () => {
    return expiredCard ? expiredCardText : overdueBalanceText;
  }

  return (
    <Modal isOpen={isAuctionModal} centered>
      <ModalHeader className="pb-0 ml-4" tag="h1" toggle={toggle} />
      <ModalBody className="pt-0 mx-4 mb-4">
        {renderModalBody()}
      </ModalBody>
    </Modal>
  );
};

export default AuctionInfoModal;
